import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { ArrowRight, CalendarClock, Eye, Loader2 } from 'lucide-react';
import { getToken } from '../../services/tokenService';

const API = process.env.REACT_APP_BACKEND_URL;
const fr = (iso) => (iso ? new Date(`${iso}T12:00:00`).toLocaleDateString('fr-FR') : '—');

export const ApercuDateEffet = ({ c, id, modifiable, pret, setPret, email, setEmail }) => {
  const [url, setUrl] = useState(null);
  const [busy, setBusy] = useState(false);
  const voir = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/api/admin/date-effet/${c.produit}/${encodeURIComponent(c.id)}/apercu`, { date_effet: c.apres.date_effet, date_fin: c.apres.date_fin },
        { headers: { Authorization: `Bearer ${getToken()}` }, responseType: 'blob' });
      setUrl(URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' })));
      setPret(true);
    } catch { toast.error("Aperçu impossible"); } finally { setBusy(false); }
  };
  return (
    <div className="mt-2 space-y-2 rounded-lg border border-slate-200 bg-white p-2.5 text-xs text-slate-700" data-testid={`klarys-date-effet-${id}`}>
      <p className="flex items-center gap-1.5 font-semibold text-slate-800"><CalendarClock className="h-3.5 w-3.5 text-[#0a3d62]" /> {c.libelle} — {c.nom || c.reference}</p>
      <div className="flex flex-wrap items-center gap-2" data-testid={`klarys-date-effet-comparatif-${id}`}>
        <span className="rounded bg-slate-100 px-2 py-1 line-through decoration-slate-400">{fr(c.avant?.date_effet)} → {fr(c.avant?.date_fin)}</span>
        <ArrowRight className="h-3.5 w-3.5 text-slate-400" />
        <span className="rounded bg-emerald-50 px-2 py-1 font-semibold text-emerald-800">{fr(c.apres?.date_effet)} → {fr(c.apres?.date_fin)}</span>
      </div>
      {modifiable && (
        <>
          <button type="button" onClick={voir} disabled={busy} className="inline-flex items-center gap-1.5 rounded-md border border-[#0a3d62] px-2.5 py-1 font-semibold text-[#0a3d62] hover:bg-sky-50" data-testid={`klarys-date-effet-apercu-${id}`}>
            {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Eye className="h-3.5 w-3.5" />} Voir l'aperçu PDF
          </button>
          {url && <iframe title="Aperçu attestation" src={url} className="h-72 w-full rounded border" data-testid={`klarys-date-effet-pdf-${id}`} />}
          <label className="flex items-center gap-1.5">
            <input type="checkbox" checked={email} disabled={!c.email} onChange={(e) => setEmail(e.target.checked)} data-testid={`klarys-date-effet-email-${id}`} />
            Envoyer la nouvelle attestation par e-mail {c.email ? `à ${c.email}` : '(aucune adresse)'}
          </label>
          {!pret && <p className="text-amber-700" data-testid={`klarys-date-effet-apercu-requis-${id}`}>Ouvrez l'aperçu PDF pour activer « Valider et rééditer ».</p>}
        </>
      )}
    </div>
  );
};
